export default "__VITE_ASSET__CLsyonkJ__"